@if (authService.user$ | async; as user) {
  @if (authVersion === 'mobile') {
    <app-download-manager layout="mobile"></app-download-manager>
    <app-subcategory-header
      [sectionWithSubcategory]="userDropdown"
      [includeMainPageUrl]="false"
      [mobileMenuIsOpen]="mobileMenuIsOpen"
    ></app-subcategory-header>
  }
  @if (authVersion === 'desktop') {
    <app-download-manager layout="desktop"></app-download-manager>
    <app-menu-dropdown [dropdown]="userDropdown"
      [userDropdown]="true"
    ></app-menu-dropdown>
  }
} @else {
  @if (authVersion === 'mobile') {
    <div class="mobile__dealer-account">
      <h2 class="subheading">
        {{ 'template.site-header.dealer-account' | translate }}
      </h2>
      <div class="mobile__dealer-section">
        <a [routerLink]="'/login' | translateRoute"
          class="mobile__dealer-link user-link">
          <span appIcon="user"></span>
          <span>{{ 'navigation.dealer-login' | translate }}</span>
        </a>
        <a [routerLink]="'/register' | translateRoute"
          class="mobile__dealer-link user-link"
          >
          {{ 'navigation.register' | translate }}
        </a>
      </div>
    </div>
  }
  @if (authVersion === 'desktop') {
    <a [routerLink]="'/login' | translateRoute"
      class="user-link"
      >
      <span appIcon="user"></span>
      <span>{{ 'navigation.dealer-login' | translate }}</span>
    </a>
    <a [routerLink]="'/register' | translateRoute"
      class="user-link"
      >
      {{ 'navigation.register' | translate }}
    </a>
  }
}




